import * as React from 'react';

import type { UsersFilterContextValue } from './UsersFilterContext.types';

import { UsersFilterContext } from './UsersFilterProvider';

export function useUsersFilter(): UsersFilterContextValue {
  const context = React.useContext(UsersFilterContext);

  if (!context) {
    throw new Error('useUsersFilter must be used within UsersFilterProvider');
  }

  return context;
}
